export const EMPTY_SHARING_RESOURCE = {
	message: '',
	previewImageUrl: '',
	petitionTitle: '',
	shareUrl: '',
	recommendedGroup: { name: '', url: '', metadata: { memberCount: 0, imageUrl: '', source: '' } },
} as const;
